import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import isNumber from 'lodash/isNumber';
import queryString from 'query-string';

// State
import {
    getCategories,
    unloadCategory,
    sortCategories,
} from '../../store/actions/category';

// Components
import CategoryList from './CategoryList';
import Loader from '../utils/Loader';
import Breadcrumb from '../Breadcrumb';

// CSS
import '../../css/categories.css';

class Category extends Component {
    constructor(props) {
        super(props);

        // Get sort params
        const query = !!props.location ? queryString.parse(props.location.search) : {};
        let pg = !!query.pg ? query.pg : '';
        let sort = !!query.sort ? query.sort : '';
        let dir = !!query.dir ? query.dir : '';

        this.state = {
            sort: sort,
            sort_order: dir,
            pg: pg ? parseInt(pg, 0) - 1 : 0,
            pushState: !!this.props.pushState ? this.props.pushState : false,
        };
    }

    static initialAction(store, props) {
        let permalink = props.params
            ? props.params.permalink
            : props.match.params.permalink;

        // Get sort params
        const query = !!props.location ? queryString.parse(props.location.search) : {};
        let pg = !!query.pg ? parseInt(query.pg, 0) + 1 : 1;
        let sort = !!query.sort ? query.sort : '';
        let dir = !!query.dir ? query.dir : '';

        let res =
            store !== null
                ? getCategories(permalink, sort, dir, pg)
                : props.getCategories(permalink, sort, dir, pg);
        return res;
    }

    componentDidMount() {
        if (!isNumber(this.props.category.id)) {
            Category.initialAction(null, this.props);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const prevQuery = !!this.props.location
            ? queryString.parse(this.props.location.search)
            : {};
        const nextQuery = !!nextProps.location
            ? queryString.parse(nextProps.location.search)
            : {};

        const prevPg = !!prevQuery.pg ? prevQuery.pg : '';
        const nextPg = !!nextQuery.pg ? nextQuery.pg : '';

        const prevSort = !!prevQuery.sort ? prevQuery.sort : '';
        const nextSort = !!nextQuery.sort ? nextQuery.sort : '';

        const prevDir = !!prevQuery.dir ? prevQuery.dir : '';
        const nextDir = !!nextQuery.dir ? nextQuery.dir : '';

        if (prevPg !== nextPg || prevSort !== nextSort || prevDir !== nextDir) {
            this.setState(
                {
                    pg: !!nextPg ? parseInt(nextPg, 0) : 0,
                    sort: !!nextSort ? nextSort : '',
                    sort_order: !!nextDir ? nextDir : '',
                },
                () => Category.initialAction(null, this.props)
            );
        }
    }

    componentDidUpdate(nextProps) {
        if (nextProps.match.params.permalink !== this.props.match.params.permalink) {
            Category.initialAction(null, this.props);
        }
    }

    componentWillUnmount() {
        this.props.unloadCategory();
    }

    render() {
        let cat = (
            <div className="pt2 pb2">
                <Loader />
            </div>
        );
        let helmet = null;

        let title = '';
        if (this.props.siteInfo.site) {
            title += this.props.siteInfo.site.title;
        }
        if (this.props.category.title) {
            if (title !== '') title += ' | ';
            title += this.props.category.title;
        }

        // console.log(title);

        helmet =
            title !== '' ? (
                <Helmet>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                    <meta property="og:description" content={title} />
                    <meta property="twitter:title" content={title} />
                </Helmet>
            ) : null;

        // console.log(this.props.category.id, this.props.category.isLoading)

        // Category has been loaded
        if (!this.props.category.isLoading && this.props.category.id) {
            const arrayObj = this.props.category.categories.length
                ? this.props.category.categories
                : [this.props.category];

            cat = arrayObj.map((category, i) => {
                return (
                    <CategoryList
                        key={i}
                        catIndex={i}
                        category={category}
                        sort={this.props.sortCategories}
                    />
                );
            });

            // Loading is over, but no category found
        } else if (!this.props.category.isLoading) {
            cat = <h2 className="pt2 pb2 centered">Category not found</h2>;
        }

        return (
            <div className="body_container">
                <Breadcrumb structure={this.props.category.structure} />
                {helmet}
                <main>{cat}</main>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteInfo: state.siteInfo,
        category: state.category,
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        { getCategories, unloadCategory, sortCategories }
    )(Category)
);



// WEBPACK FOOTER //
// ./src/components/category/Category.js